import { Component, inject } from '@angular/core';
import { ClosureTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ClosureTypeCreateDto,
  ClosureTypeDto,
  ClosureTypeExcelDownloadDto,
  ClosureTypeUpdateDto,
} from '../proxy/controlling/dtos/closure-type';
import { CLOSURETYPE_CONFIG, CLOSURETYPE_FIELDS } from './closure-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-closure-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ClosureTypeService, ConfirmationService],
  templateUrl: './closure-type.html',
  styleUrl: './closure-type.scss',
})
export class ClosureType extends BaseCrudComponent<
  ClosureTypeDto,
  ClosureTypeCreateDto,
  ClosureTypeUpdateDto,
  ClosureTypeExcelDownloadDto
> {
  service = inject(ClosureTypeService);
  config = CLOSURETYPE_CONFIG;
  fields = CLOSURETYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: ClosureTypeDto): ClosureTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ClosureType';
  }
}
